/**
 * @fileoverview Start Button - スタートボタンの制御
 * ゲーム開始に関する単純な制御を提供
 */

import { GameStatus } from '../../core/constants.js';
import gameState from '../../core/game-state.js';
import { gameStart } from '../../gameplay/game-controls.js';
import { STATE_PATHS } from '../../shared/constants/state-paths.js';
import { notifyStartClicked, shouldBlockStart } from '../tutorial/tutorial-guards.js';

import { skillSystem } from './skill-system.js';

export {};

const button = document.getElementById('button');

// スキル関連の連携は skill-system.js へ依存

button.addEventListener('mousedown', () => {
  // Animate only when in Title status
  const status = gameState.getState(STATE_PATHS.CORE_STATUS);
  if (status === GameStatus.Title) {
    button.classList.add('clicked');
  }
});

button.addEventListener('mouseup', async () => {
  // Start only allowed in Title status
  const status = gameState.getState(STATE_PATHS.CORE_STATUS);
  if (status === GameStatus.Title) {
    if (shouldBlockStart()) {
      return;
    }
    await gameStart();
    notifyStartClicked();
  } else {
    // ignore when not in Title (e.g., during animations or already playing)
  }
});
// スキルボタン関連の連携は skill-system.js へ依存

// 設定関連制御は menu-system.js へ依存
// メニューシステム関連の制御は menu-system.js へ依存

/**
 * スタートボタンの初期化
 * 各サブシステムの初期化処理を実行
 */
export function initializeStartButton() {
  // SkillSystemの初期化
  skillSystem.initialize();

  // GameMode表示の初期値設定（F5などリロード時にGameStateを補完）
  const settings = gameState.getState(STATE_PATHS.SETTINGS);
  const currentMode = settings?.gameMode || 'Blitz';
  const gameModeValueEl = document.getElementById('game-mode-value');
  if (gameModeValueEl) {
    gameModeValueEl.textContent = currentMode;
  }
}
